import {request} from './request'

// 首页数据-导出
export function getDetail(id){
    return request({
        // 配置参数--url
        url:'/api/goods/'+id,
    })
}
